import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Manifesto } from "@/components/Manifesto";
import { Timeline } from "@/components/Timeline";
import { Stack } from "@/components/Stack";
import { Mindset } from "@/components/Mindset";
import { Vision } from "@/components/Vision";
import { FutureProjects } from "@/components/FutureProjects";
import { Principles } from "@/components/Principles";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function App() {
  return (
    <div className="relative min-h-screen bg-background text-foreground antialiased">
      <Nav />
      <main>
        <Hero />
        <Manifesto />
        <Timeline />
        <Stack />
        <Mindset />
        <Vision />
        <FutureProjects />
        <Principles />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
